import React, { Component } from "react";
import { TabContent, TabPane, Row, Col } from "reactstrap";

// Components
import HeaderContainer from "../Header/HeaderContainer";
import OrganisationsNavigation from "./OrganisationsNavigation";
import OrganisationsSummary from "./OrganisationsSummary";
import OrganisationsList from "./OrganisationsList";
import OrganisationReports from "./OrganisationReports";
import SystemAnnouncement from "../SystemAnnouncements/SystemAnnouncementContainer";
import ClusterInformationList from "./ClusterInformationList";

// Strings
import { getMessage } from "CONFIG/i18n";

// Styles
import "./Organisations.less";

class Organisations extends Component {
  render() {
    const { currentActiveTab, showTable } = this.props;

    return (
      <div>
        {/* Header with title, Add Organization button, and search */}
        <HeaderContainer
          title={getMessage("ORGANIZATIONS")}
          headerButtonText={getMessage("ADD_ORGANIZATION")}
          history={this.props.history}
          handleSearchString={this.props.handleSearchString}
          onCancelButton={this.props.onCancelButton}
          isDashboard={true}
          gotoAddOrganization={this.props.gotoAddOrganization}
        />

        {/* Summary Statistics Bar */}
        <OrganisationsSummary 
          summaryData={this.props.summaryData}
          isKurentoServerOn={this.props.isKurentoServerOn}
        />

        {/* Main Content Area with Navigation and Tabs */}
        <div className="reportsPageContainer">
          {/* Navigation Sidebar */}
          <OrganisationsNavigation 
            currentActiveTab={currentActiveTab}
            usingKmsCluster={this.props.usingKmsCluster}
          />
          
          {/* Tab Content Area */}
          <div className="reportsContent">
            {showTable && (
              <TabContent activeTab={currentActiveTab}>
                {/* Tab 1: Organizations List */}
                <TabPane tabId="1">
                  {currentActiveTab === "1" && (
                    <Row className="noMargin">
                      <Col sm="12" className="noPadding">
                        <OrganisationsList
                          organizationsData={this.props.responseObject.data}
                          gotoEditOrganization={this.props.gotoEditOrganization}
                          getAvailableModules={this.props.getAvailableModules}
                          showDeleteConfirmationModal={this.props.showDeleteConfirmationModal}
                          getAllUserData={this.props.getAllUserData}
                          handleSearchString={this.props.handleSearchString}
                          onCancelButton={this.props.onCancelButton}
                          sortCustomerList={this.props.sortCustomerList}
                          language={this.props.language}
                        />
                      </Col>
                    </Row>
                  )}
                </TabPane>

                {/* Tab 2: System Announcements */}
                <TabPane tabId="2">
                  {currentActiveTab === "2" && (
                    <SystemAnnouncement language={this.props.language} />
                  )}
                </TabPane>

                {/* Tab 3: Cluster Information */}
                <TabPane tabId="3">
                  {currentActiveTab === "3" && (
                    <ClusterInformationList
                      clusterData={this.props.clusterData}
                      turnClusterData={this.props.turnClusterData}
                      getClusterInfo={this.props.getClusterInfo}
                      getTurnClusterInfo={this.props.getTurnClusterInfo}
                      lastRefreshTime={this.props.lastRefreshTime}
                      lastRefreshTimeTurn={this.props.lastRefreshTimeTurn}
                      retireInstance={this.props.retireInstance}
                      usingTurnCluster={this.props.usingTurnCluster}
                      language={this.props.language}
                    />
                  )}
                </TabPane>

                {/* Tab 4: Organization Reports */}
                <TabPane tabId="4">
                  {currentActiveTab === "4" && (
                    <Row className="noMargin">
                      <Col sm="12" className="noPadding">
                        <OrganisationReports
                          organizationsData={this.props.responseObject.data}
                          getMonthlyConcurrentSessionsReport={this.props.getMonthlyConcurrentSessionsReport}
                          getDailyConcurrentSessionsReport={this.props.getDailyConcurrentSessionsReport}
                          language={this.props.language}
                        />
                      </Col>
                    </Row>
                  )}
                </TabPane>
              </TabContent>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Organisations;